import * as setup from '@/setup';
import Button from '@/objects/button';
import Header from '@/objects/header';
import * as audio from '@/utils/audio';
import * as pwa from '@/utils/pwa';
import { HEADER_HEIGHT } from '@/constants';

export default class Settings extends Phaser.Scene {
	constructor() {
		super({ key: 'Settings' });
		this.audioEnabled = true;
		this.onIcon = null;
		this.offIcon = null;
	}

	create() {
		const width = this.sys.game.config.width;
		const height = this.sys.game.config.height;
		const centerX = width / 2;

		// Background
		this.add
			.image(centerX, height / 2, 'background')
			.setOrigin(0.5, 0.5);

		// Header
		this.createHeader(centerX);

		// Carica stato audio corrente
		this.audioEnabled = audio.getAudioEnabled();

		// Crea sezione Sounds
		this.createSoundsSection(centerX);

		// Crea sezione Installa App (sempre visibile)
		this.createInstallSection(centerX);
	}

	createHeader(centerX) {
		const headerY = HEADER_HEIGHT / 2;

		// Usa il componente Header
		new Header(this, 'IMPOSTAZIONI');

		// Pulsante back (icona) - separato dal componente Header
		const backArrow = this.add.image(40, headerY, 'back-icon');
		backArrow.setOrigin(0, 0.5);
		backArrow.setInteractive({ useHandCursor: true });

		backArrow.on('pointerup', () => {
			audio.playSound(this, 'button-click');
			this.scene.start('MainMenu');
		});
	}

	createSoundsSection(centerX) {
		const width = this.sys.game.config.width;
		const startY = 200;
		const boxWidth = width * 0.8;
		const boxHeight = 300;
		const boxY = startY + 100;

		// Box blu per contenere tutto
		const blueBox = this.add.image(centerX, boxY, 'orange-box');
		blueBox.setDisplaySize(boxWidth, boxHeight);
		blueBox.setOrigin(0.5, 0.5);

		// Titolo "SUONI" nell'header del box
		const headerY = boxY - boxHeight / 2 + 20;
		this.add.text(centerX, headerY, 'SUONI', {
			fontSize: 36,
			fontFamily: 'Luckiest Guy',
			fill: '#FFFFFF',
			align: 'center',
			fontStyle: 'bold'
		}).setOrigin(0.5);

		// Container per toggle ON/OFF
		const toggleY = boxY+35;
		const toggleSpacing = 130;

		// Toggle ON
		// on1: quando audio è disattivo, on2: quando audio è attivo
		const onX = centerX - toggleSpacing / 2;
		const onIconKey = this.audioEnabled ? 'on2' : 'on1';
		this.onIcon = this.add.image(onX, toggleY, onIconKey);
		this.onIcon.setInteractive({ useHandCursor: true });
		this.onIcon.setScale(0.8);

		// Toggle OFF
		// off1: quando audio è attivo, off2: quando audio è disattivo
		const offX = centerX + toggleSpacing / 2;
		const offIconKey = !this.audioEnabled ? 'off2' : 'off1';
		this.offIcon = this.add.image(offX, toggleY, offIconKey);
		this.offIcon.setInteractive({ useHandCursor: true });
		this.offIcon.setScale(0.8);

		// Event handlers
		const scene = this;
		this.onIcon.on('pointerup', function() {
			if (!scene.audioEnabled) {
				scene.setAudioEnabled(true);
				// Aggiorna icone: on2 (attivo) e off1 (non selezionato)
				scene.onIcon.setTexture('on2');
				scene.offIcon.setTexture('off1');
			}
		});

		this.offIcon.on('pointerup', function() {
			if (scene.audioEnabled) {
				scene.setAudioEnabled(false);
				// Aggiorna icone: on1 (non selezionato) e off2 (disattivo)
				scene.onIcon.setTexture('on1');
				scene.offIcon.setTexture('off2');
			}
		});
	}

	setAudioEnabled(enabled) {
		this.audioEnabled = enabled;
		audio.setAudioEnabled(enabled);
	}

	/**
	 * Crea la sezione per installare l'app come PWA
	 * @param {number} centerX - Coordinata X centrale
	 * @returns {void}
	 */
	createInstallSection(centerX) {
		var width = this.sys.game.config.width;
		var boxWidth = width * 0.8;
		var boxHeight = 180;
		var boxY = 580;

		// Box per contenere la sezione
		var installBox = this.add.image(centerX, boxY, 'blue-box');
		installBox.setDisplaySize(boxWidth, boxHeight);
		installBox.setOrigin(0.5, 0.5);

		// Titolo sezione
		var headerY = boxY - boxHeight / 2 + 20;
		this.add.text(centerX, headerY, 'INSTALLA APP', {
			fontSize: 36,
			fontFamily: 'Luckiest Guy',
			fill: '#FFFFFF',
			align: 'center',
			fontStyle: 'bold'
		}).setOrigin(0.5);

		// Pulsante installa
		var scene = this;
		var installButton = new Button(
			this,
			centerX,
			boxY + 30,
			'green-button',
			1.2,
			'Installa',
			false
		);

		installButton.on('pointerup', function() {
			audio.playSound(scene, 'button-click');
			pwa.showInstallPrompt().then(function(accepted) {
				if (accepted) {
					// Nasconde il pulsante dopo installazione
					installButton.setVisible(false);
					installBox.setVisible(false);
				}
			});
		});
	}
}
